import axios from 'axios';
import getRoles from '../utils/roles';
import { ADMIN_API_BASE, AUTH_API_BASE, CUSTOMER_API_BASE, EMAIL_API_BASE } from '../env';

export async function getRealmRoles(token) {
  const response = await axios.get(`${AUTH_API_BASE}/managers/roles`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const roles = getRoles();
  const realmRoles = response.data.filter(role => role && roles.includes(role.name));
  return realmRoles.sort((a, b) => a.name.localeCompare(b.name));
}

export async function getLocationsForPortal(token) {
  const response = await axios.get(`${ADMIN_API_BASE}/facilities/portal`, {
    params: {
      limit: 55,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function getLocations(token) {
  const response = await axios.get(`${ADMIN_API_BASE}/facilities`, {
    params: {
      limit: 55,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function getFacility(facility, options) {
  try {
    const { token, signal } = options;
    const facilityResponse = await axios.get(`${ADMIN_API_BASE}/facilities/${facility}`, {
      ...(signal ? { signal } : {}),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return facilityResponse.data;
  } catch (err) {
    throw new Error(err.message);
  }
}

export async function getActiveCustomers(facility, options) {
  try {
    const { token, type } = options;

    const activeCustomersResponse = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/get/active/customers/${facility}`, {
      params: {
        type,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return activeCustomersResponse.data;
  } catch (err) {
    throw new Error(err.message);
  }
}

export async function sendEmail({ from, to, subject, body, token, facility, customer }) {
  try {
    await axios.post(`${EMAIL_API_BASE}/send/email`, {
      from,
      to,
      subject,
      body,
      facility,
      customer,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return true;
  } catch (err) {
    throw new Error(err.response.data.error);
  }
}

export async function listEditorEmailTemplates(token, options = {}) {
  const response = await axios.get(`${EMAIL_API_BASE}/editor/templates`, {
    params: options,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function createEditorEmailTemplate(template, token) {
  const response = await axios.post(`${EMAIL_API_BASE}/editor/templates`, template, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function updateEditorEmailTemplate(id, template, token) {
  const response = await axios.put(`${EMAIL_API_BASE}/editor/templates/${id}`, template, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function listEditorEmailTemplateVersions(id, token) {
  const response = await axios.get(`${EMAIL_API_BASE}/editor/templates/${id}/versions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function previewEditorEmailTemplate(template, token) {
  const response = await axios.post(`${EMAIL_API_BASE}/editor/templates/preview`, template, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function listEditorEmailTemplateProperties(token, options = {}) {
  const response = await axios.get(`${EMAIL_API_BASE}/editor/template-properties`, {
    params: options,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function createEditorEmailTemplateProperty(property, token) {
  const response = await axios.post(`${EMAIL_API_BASE}/editor/template-properties`, property, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function updateEditorEmailTemplateProperty(id, property, token) {
  const response = await axios.put(`${EMAIL_API_BASE}/editor/template-properties/${id}`, property, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}



// WEBPACK FOOTER //
// ./src/utils/commonApi.js